function handleMenus() {
    const menuToggle = document.getElementById('menu-open');

    if (menuToggle) {
        menuToggle.addEventListener('change', () => {
            const htmlElement = document.querySelector('html');

            if (htmlElement) {
                if (menuToggle.checked) {
                    htmlElement.classList.add('menu-open');
                }
                else {
                    htmlElement.classList.remove('menu-open');
                }
            }
        });
    }
}

function handleSubmenus() {
    const submenuContainers = document.querySelectorAll('nav .menu-item-has-children');

    submenuContainers.forEach((submenuContainer) => {
        const submenuToggle = submenuContainer.querySelector('input[type="checkbox"]');

        if (submenuToggle) {
            submenuToggle.addEventListener('change', () => {
                if (submenuToggle.checked) {
                    submenuContainer.classList.add('submenu-open');
                }
                else {
                    submenuContainer.classList.remove('submenu-open');
                }
            });
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    handleMenus();
    handleSubmenus();
});
